import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button, App } from "antd";
import http from "../../services/http";

const ForgotPassword = () => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const onFinish = async (values) => {
    const { email } = values;
    setLoading(true);

    try {
      await http.post("/api/doctor/forgot-password", { email });
      setEmailSent(true);
      message.success("Liên kết đặt lại mật khẩu đã được gửi đến email của bạn.");
    } catch (err) {
      console.error("Forgot password error:", err);
      message.error(
        err?.message || "Không thể gửi liên kết đặt lại. Vui lòng thử lại."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      {/* Left Image Panel */}
      <div
        className="relative block h-96 lg:h-auto bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: "url(/images/signup_bg.png)",
        }}
      >
        <div className="absolute inset-0 bg-black/20" />
        <div className="absolute bottom-8 left-8 right-8">
          <div className="bg-black/40 backdrop-blur-sm text-white rounded-lg p-4">
            <h3 className="text-2xl font-bold">Đăng nhập Cổng thông tin Bác sĩ</h3>
            <p className="text-base opacity-90">
              Truy cập bảng điều khiển của bạn để quản lý các cuộc tư vấn bệnh nhân, theo dõi tiến trình và cung cấp dịch vụ chăm sóc ảo một cách dễ dàng.
            </p>
          </div>
        </div>
        <div className="absolute top-6 left-6">
          <Link to="/">
            <img
              src="/images/logo_white.png"
              alt="MedRev"
              className="h-12 w-auto"
            />
          </Link>
        </div>
        <div className="absolute top-6 right-6 text-white/90 text-base font-medium">
          medrev.com
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center justify-center p-6 bg-white h-full">
        <div className="w-full max-w-md px-6">
          {/* Logo */}
          <div className="mb-6">
            <Link to="/">
              <img
                src="/images/logo.png"
                alt="MedRev Logo"
                className="h-16 w-auto mb-5"
              />
            </Link>
            <h1 className="text-2xl font-bold text-brand-dark">
              Quên mật khẩu?
            </h1>
          </div>

          {!emailSent ? (
            <Form
              layout="vertical"
              onFinish={onFinish}
              requiredMark={false}
              className="space-y-4"
            >
              <Form.Item
                label={
                  <span className="text-gray-700 text-sm">
                    Nhập địa chỉ email đã đăng ký của bạn
                  </span>
                }
                name="email"
                rules={[
                  { required: true, message: "Vui lòng nhập email của bạn" },
                  { type: "email", message: "Vui lòng nhập địa chỉ email hợp lệ." },
                ]}
              >
                <Input
                  placeholder="Nhập địa chỉ email đã đăng ký của bạn"
                  className="py-2.5"
                  size="large"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  className="w-full bg-purple-600 hover:bg-purple-700 h-11 font-medium rounded-lg text-base"
                  size="large"
                >
                  Gửi liên kết đặt lại mật khẩu
                </Button>
              </Form.Item>

              <div className="text-center mt-6">
                <Link
                  to="/login"
                  className="text-sm text-purple-600 hover:underline font-medium"
                >
                  Quay lại trang đăng nhập
                </Link>
              </div>
            </Form>
          ) : (
            <div className="text-center">
              <div className="mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Email đã được gửi thành công!
                </h3>
                <p className="text-gray-600 text-sm mb-6">
                  Chúng tôi đã gửi liên kết đặt lại mật khẩu đến địa chỉ email của bạn. Vui lòng kiểm tra hộp thư đến và làm theo hướng dẫn.
                </p>
              </div>

              <Button
                type="primary"
                className="w-full bg-purple-600 hover:bg-purple-700 h-11 font-medium rounded-lg text-base mb-4"
                size="large"
                onClick={() => setEmailSent(false)}
              >
                Gửi lại liên kết
              </Button>

              <Link
                to="/login"
                className="text-sm text-purple-600 hover:underline font-medium"
              >
                Quay lại trang đăng nhập
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
